export default class {
    meetingType;
    meetingTypeId;
    presenter;
    scheduledDate;
    key;

    constructor(meetingType, meetingTypeId, presenter, scheduledDate) {
        this.meetingType = meetingType;
        this.meetingTypeId = meetingTypeId;
        this.presenter = presenter;
        this.scheduledDate = scheduledDate;
        this.key = `${meetingTypeId}-${scheduledDate}-${presenter}`;
    }

    getMeetingType() {
        return this.meetingType;
    }

    getMeetingTypeId() {
        return this.meetingTypeId;
    }

    getPresenter() {
        return this.presenter;
    }

    getScheduledDate() {
        return this.scheduledDate;
    }
}
